import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { styled } from "@mui/material";
import Rating from "@mui/material/Rating";
import React from "react";

import { useLogging } from "../logging/useLogging";
import { AppEvent, ExerciseId } from "../types";

interface FavouriteProps {
    handleClick: (id: ExerciseId, value: number | null) => void;
    id: ExerciseId;
    favourites: ReadonlyArray<ExerciseId>;
    excluded: ReadonlyArray<ExerciseId>;
}

const Favourite: React.FunctionComponent<FavouriteProps> = ({ favourites, excluded, id, handleClick }) => {
    const { logWithPayload } = useLogging();

    const handleClickWithLogging = (value: number | null) => {
        handleClick(id, value);
        logWithPayload(value ? AppEvent.FavouriteAdded : AppEvent.FavouriteRemoved, { id });
    };
    return (
        <StyledRating
            name="favourite"
            value={favourites.includes(id) ? 1 : 0}
            max={1}
            icon={<FavoriteIcon fontSize="inherit" />}
            emptyIcon={<FavoriteBorderIcon fontSize="inherit" />}
            onChange={(_, value) => handleClickWithLogging(value)}
            disabled={excluded.includes(id)}
        />
    );
};

export default Favourite;

export const StyledRating = styled(Rating)({
    marginLeft: 10,
    "& .MuiRating-iconFilled": {
        color: "#ff6d75",
    },
});
